module.exports = __webpack_public_path__ + "img/cat-single.86060db7.jpg";